import { render, staticRenderFns } from "./RejectRequestModal.vue?vue&type=template&id=fdacbd84&"
import script from "./RejectRequestModal.vue?vue&type=script&lang=js&"
export * from "./RejectRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports